export default __webpack_public_path__ + "static/lframe-business-if-9a3c8f26a5f0f19c01ecaf0417151475.png";